import Cookies from "js-cookie";
import { NotificationManager } from "react-notifications";
import Router from "next/router";

import { loader } from "./loader";
import axiosInstance from "../../config/axios";

export const STORE_AUTH = "STORE_AUTH";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_BALANCE = "UPDATE_BALANCE";
export const SYNCCOOKIES = "SYNCCOOKIES";
export const SET_UPDATE_USER = "SET_UPDATE_USER";

// export const loginAsync = data => {
//      let newData = data;
//     return async dispatch => {
//         dispatch(loader());

//         try {
//             const {data: response} = await axiosInstance.post('login', newData);
//             dispatch(loader());
//             dispatch(storeAuth(response.data));
//             console.log("status", data)

//             NotificationManager.success(response.message, '', 5000);
//             const checkoutCookies = localStorage.getItem('checkoutToLogin') ? localStorage.getItem
//             ('checkoutToLogin') : '';
//             const walletCookies = localStorage.getItem('walletToLogin') ? localStorage.getItem
//             ('walletToLogin') : '';
//             const giftcardCookies = localStorage.getItem('giftcardToLogin') ? localStorage.getItem
//             ('giftcardToLogin') : '';
//             const cartCookies = localStorage.getItem('cartToLogin') ? localStorage.getItem
//             ('cartToLogin') : '';
//            // console.log(walletCookies, "walletCookies")

//             if (checkoutCookies === '/checkout') {
//                 Router.push('/checkout');
//                // localStorage.removeItem('checkoutToLogin')
//             } else if (walletCookies.length > 0 || walletCookies) {
//                // Router.push({  pathname: '/wallet', query:  walletCookies})
//                 //Router.push({query:  walletCookies}, '/wallet' )
//                // localStorage.removeItem('walletToLogin')
//                localStorage.setItem('walletCookies', (walletCookies));
//     Router.push('/wallet');

//             }
//             else if (giftcardCookies.length > 0 || giftcardCookies) {

//                localStorage.setItem('giftcardCookies', (giftcardCookies));
//     Router.push('/giftcard');

//             }
//             else if (cartCookies.length > 0 || cartCookies) {
//               localStorage.setItem('cartCookies', (cartCookies));
//    Router.push('/cart');

//            }

//             else {
//                 Router.push('/');
//             }
//         } catch (error) {
//             console.log(error);
//             dispatch(loader());
//             NotificationManager.error(error.response.data.message, '', 5000);
//         }

//     }
//   };

export const loginAsync = (data) => {
  let newData = data;

  return async (dispatch) => {
    dispatch(loader());

    try {
      const { data: response } = await axiosInstance.post("login", newData);

      dispatch(loader());
      dispatch(storeAuth(response.data));
      NotificationManager.success(response.message, "", 5000);

      const checkoutCookies = localStorage.getItem("checkoutToLogin")
        ? localStorage.getItem("checkoutToLogin")
        : "";

      const walletCookies = localStorage.getItem("walletToLogin")
        ? localStorage.getItem("walletToLogin")
        : "";

      const giftcardCookies = localStorage.getItem("giftcardToLogin")
        ? localStorage.getItem("giftcardToLogin")
        : "";

      const cartCookies = localStorage.getItem("cartToLogin")
        ? localStorage.getItem("cartToLogin")
        : "";

      if (checkoutCookies === "/checkout") {
        Router.push("/checkout");
      } else if (walletCookies.length > 0 || walletCookies) {
        localStorage.setItem("walletCookies", walletCookies);
        Router.push("/wallet");
      } else if (giftcardCookies.length > 0 || giftcardCookies) {
        localStorage.setItem("giftcardCookies", giftcardCookies);
        Router.push("/giftcard");
      } else if (cartCookies.length > 0 || cartCookies) {
        localStorage.setItem("cartCookies", cartCookies);
        Router.push("/cart");
      } else {
        Router.push("/");
      }
    } catch (error) {
      console.log(error);

      // Handle unverified account
      if (error.response?.status === 403) {
        try {
          dispatch(loader());

          localStorage.setItem("signupToVerification", JSON.stringify(newData));

          Router.push("/otp-verification");
        } catch (verificationError) {
          dispatch(loader());

          NotificationManager.error(
            verificationError.response?.data?.message ||
              "Unable to initiate verification. Please try again.",
            "",
            5000,
          );
        }

        return;
      }

      dispatch(loader());

      NotificationManager.error(
        error.response?.data?.message || "Login failed. Please try again.",
        "",
        5000,
      );
    }
  };
};

export const updateBalance = (balance) => ({ type: UPDATE_BALANCE, balance });

export const storeAuth = (data) => {
  localStorage.setItem(
    "user",
    JSON.stringify({ ...data.user, referral_settings: data.referral_settings }),
  );
  // Cookies.set("token", data.token);
  Cookies.set("token", data.token, {
    secure: true, // ← HTTPS only
    sameSite: "lax", // ← CSRF protection
    // HttpOnly can only be set server-side — ask backend to set this
  });
  Cookies.set("user", JSON.stringify(data.user));

  return {
    type: LOGIN,
    data,
  };
};

export const syncCookiesToStore = (data) => ({ type: SYNCCOOKIES, data });

// export const logout = () => {
//   Cookies.remove("token");
//   Cookies.remove("user");
//   Cookies.remove("singleOrderId");
//   localStorage.removeItem("orders");
//   localStorage.removeItem("user");

//   return {
//     type: LOGOUT,
//   };
// };

// store/actions/auth.js
export const logout = (token) => async (dispatch) => {
  try {
    if (token) {
      await axiosInstance.post(
        "logout",
        { token },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    }
  } catch (error) {
    console.error("Logout API error:", error);
  } finally {
    Cookies.remove("token");
    Cookies.remove("user");
    Cookies.remove("singleOrderId"); // ← add this
    localStorage.clear();
    dispatch({ type: LOGOUT });
    Router.push("/");
  }
};
